import { generateTitle } from 'utils/charts/common';
import {
    LESS_THAN_OR_EQUAL_TO_TEN_PERCENT_ABOVE_UPPER_LIMIT,
    MORE_THAN_TEN_PERCENT_ABOVE_UPPER_LIMIT,
    MORE_THAN_TWENTY_PERCENT_ABOVE_UPPER_LIMIT,
    noResultsText,
    OUTLIER_DETECTION_TITLE,
    PERCENT_OF_EXECUTION_ONLY_TRADES,
    RED_DIAMOND_GRAPHIC_URL,
    RED_WHITE_CIRCLE_10_URL,
    RED_WHITE_CIRCLE_20_URL,
    RED_WHITE_CIRCLE_5_URL
} from 'utils/charts/constants';

const moreThanTenPercentAboveLimitGraphic = {
    image: {
        type: 'image',
        style: {
            image: RED_WHITE_CIRCLE_5_URL,
            width: 12,
            height: 12,
            opacity: 0.4
        },
        cursor: 'default',
        bottom: 10
    },
    text: {
        type: 'text',
        style: {
            text: LESS_THAN_OR_EQUAL_TO_TEN_PERCENT_ABOVE_UPPER_LIMIT,
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '3%'
    }
};

const tenPercentAboveLimitGraphic = {
    image: {
        type: 'image',
        style: {
            image: RED_WHITE_CIRCLE_10_URL,
            width: 12,
            height: 12
        },
        cursor: 'default',
        bottom: 10,
        left: '37%'
    },
    text: {
        type: 'text',
        style: {
            text: MORE_THAN_TEN_PERCENT_ABOVE_UPPER_LIMIT,
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '40%'
    }
};

const twentyPercentAboveLimitGraphic = {
    image: {
        type: 'image',
        style: {
            image: RED_WHITE_CIRCLE_20_URL,
            width: 12,
            height: 12
        },
        cursor: 'default',
        bottom: 10,
        left: '74%'
    },
    text: {
        type: 'text',
        style: {
            text: MORE_THAN_TWENTY_PERCENT_ABOVE_UPPER_LIMIT,
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        bottom: 10,
        left: '77%'
    }
};

const rmSymbolAndTextGraphic = {
    image: {
        type: 'image',
        style: {
            image: RED_DIAMOND_GRAPHIC_URL,
            width: 12,
            height: 12
        },
        cursor: 'default',
        top: 5,
        right: 45
    },
    text: {
        type: 'text',
        style: {
            text: 'RM',
            font: '10px "Outfit" 400',
            fill: '#929292'
        },
        cursor: 'default',
        top: 5,
        right: 20
    }
};

export const scenarioThreeNoResultOutlierChartPartOneOptions = () => {
    return {
        title: generateTitle(OUTLIER_DETECTION_TITLE),
        xAxis: {
            type: 'category',
            axisTick: { show: false },
            axisLine: { show: false },
            axisLabel: { show: false }
        },
        yAxis: {
            type: 'value',
            name: PERCENT_OF_EXECUTION_ONLY_TRADES,
            nameLocation: 'center',
            nameGap: 75,
            nameTextStyle: {
                padding: [20, 0, 0, 0],
                color: '#8DA8B3',
                fontWeight: 'bold'
            }
        },
        grid: {
            width: '350px',
            left: '95px'
        },
        graphic: [
            moreThanTenPercentAboveLimitGraphic.image,
            moreThanTenPercentAboveLimitGraphic.text,
            tenPercentAboveLimitGraphic.image,
            tenPercentAboveLimitGraphic.text,
            twentyPercentAboveLimitGraphic.image,
            twentyPercentAboveLimitGraphic.text,
            rmSymbolAndTextGraphic.image,
            rmSymbolAndTextGraphic.text,
            noResultsText
        ]
    };
};
